import BaseNormalPass from "./BaseNormalPass";

/**
 * ClearPass
 */
export default class ClearPass extends BaseNormalPass {
  getName() {
    return 'clear';
  }
  init(layer, config) {
    super.init(layer, config);
  }
  render() {
    this.rendererService.clear({
      color: [0, 0, 0, 0],
      depth: 1,
      framebuffer: null
    });
  }
}